import { put, select, takeEvery } from 'typed-redux-saga/macro';
import { selectCurrentPaydayRangeWithFallback } from 'reducers/selectors';
import { BUDGETING_PERIOD_CHANGED, EDIT_CATEGORY_SUCCESS, UPDATE_CATEGORIES_PREFERENCES_SUCCESS, } from 'actions/types';
import { ADD_SUBSCRIPTIONS_SUCCESS, ADD_TXN_TO_SUBSCRIPTION_BY_ID_SUCCESS, ADD_TXNS_TO_SUBSCRIPTION_SUCCESS, CANCEL_SUBSCRIPTIONS_SUCCESS, DELETE_TXN_FROM_SUBSCRIPTION_SUCCESS, EDIT_SUBSCRIPTIONS_SUCCESS, FETCH_COMMITTED_FOR_CURRENT_PAYDAY_RANGE, } from '../actions/types';
import { getCommitted, getSubscriptionsById } from '../actions';
import { selectIncludeIncomeSubscriptions } from '../selectors';
function* fetchCommittedForCurrentPaydayRange() {
    const currentPaydayRangeWithFallback = yield* select(selectCurrentPaydayRangeWithFallback);
    const includeIncome = yield* select(selectIncludeIncomeSubscriptions);
    yield* put(getCommitted(currentPaydayRangeWithFallback.from, currentPaydayRangeWithFallback.to, includeIncome, 'currentPeriod'));
}
function* refetchActiveSubscription(action) {
    const { activeSubscriptionId, subscriptionTransactions } = yield* select((store) => store.subscriptions);
    if (!activeSubscriptionId)
        return;
    const editedIds = action.extra.data;
    if (!subscriptionTransactions.some(({ id }) => id in editedIds))
        return;
    yield* put(getSubscriptionsById(activeSubscriptionId));
}
function* subscriptionsSaga() {
    yield* takeEvery(EDIT_CATEGORY_SUCCESS, refetchActiveSubscription);
    yield* takeEvery((action) => [
        FETCH_COMMITTED_FOR_CURRENT_PAYDAY_RANGE,
        EDIT_SUBSCRIPTIONS_SUCCESS,
        CANCEL_SUBSCRIPTIONS_SUCCESS,
        ADD_SUBSCRIPTIONS_SUCCESS,
        ADD_TXN_TO_SUBSCRIPTION_BY_ID_SUCCESS,
        ADD_TXNS_TO_SUBSCRIPTION_SUCCESS,
        DELETE_TXN_FROM_SUBSCRIPTION_SUCCESS,
        BUDGETING_PERIOD_CHANGED,
        EDIT_CATEGORY_SUCCESS,
        UPDATE_CATEGORIES_PREFERENCES_SUCCESS,
    ].includes(action.type), fetchCommittedForCurrentPaydayRange);
}
export default subscriptionsSaga;
